import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation, useQuery } from '@apollo/client'
import Button from './Button'
import Modal from './Modal'
import { EditCreation, EditCreations } from '../graphql/mutations'
import { GetCreationTypes } from '../graphql/queries'
import SelectInput from './SelectInput'

const initialState = {
    title: '',
    originalTitle: '',
    episodeTitle: '',
    country: '',
    year: '',
    producer: '',
    season: null,
    episode: null,
    duration: '',
    type: '',
}

const initialErrorsState = {
    title: null,
    originalTitle: null,
    country: null,
    year: null,
    producer: null,
    season: null,
    episode: null,
    duration: null,
    type: null,
    generic: null,
}

const EditCreationModal = ({
    show,
    close,
    onSuccess,
    initialData,
}) => {

    const { t } = useTranslation()
    const [item, setItem] = useState(initialState)
    const [items, setItems] = useState([])
    const [editCreation] = useMutation(EditCreation)
    const [editCreations] = useMutation(EditCreations)
    
    const [errors, setErrors] = useState(initialErrorsState)

    const { data: typeData } = useQuery(GetCreationTypes)

    useEffect(() => {
        if (initialData?.title) {
            setItem(initialData)
            return
        }

        if (initialData?.length && initialData[0]?.title) {
            setItems(initialData)
            return
        }

        setItem(initialState)
    }, [initialData])

    const handleUpdate = async () => {
        if (hasInputErrors()) return
        try {
            const data = {
                type: item.type ? parseInt(item.type) : undefined,
            }

            const res = !items?.length? await editCreation({
                variables: {
                    id: parseInt(item?.id),
                    data,
                },
            }) : await editCreations({
                variables: {
                    ids: items.map((i) => parseInt(i.id)),
                    data,
                },
            })

            if (
                (
                    !items?.length
                    && (!res?.data?.editCreation || res.data.editCreation === 'FAIL')
                )
                || (
                    items.length
                    && (!res?.data?.editCreations || res.data.editCreations === 'FAIL')
                )
            ) {
                setErrors({
                    ...initialErrorsState,
                    generic: t('creations.update_error'),
                })
                return
            }

            if (onSuccess) onSuccess(res.data.editCreation || res.data.editCreations)
        } catch (err) {
            setErrors({
                ...initialErrorsState,
                generic: t('creations.update_error'),
            })
            console.log('hanldeUpdate:', err)
        }
    }

    const hasInputErrors = () => {
        let hasErrors = false
        const errorState = {
            ...initialErrorsState,
        }

        if (!item.type) {
            hasErrors = true
            errorState.type = t('reports.fill_field')
        }

        setErrors({
            ...errorState,
        })
        return hasErrors
    }

    const handleClose = () => {
        if (close) close()
        setErrors(initialErrorsState)
        setItem(initialState)
    }

    const renderActions = () => (
        <div className='modal-actions'>
            <Button
            label={t('creations.save')}
            onClick={handleUpdate}
        />
        </div>
    )

    return (
        <Modal
            className={'modal-edit-creation'}
            show={show}
            close={handleClose}
            title={t('creations.update_selected_creations')}
            renderActions={renderActions}
        >
            <p>{items?.length > 1 ? t('creations.selected_creations', { count: items?.length }) : t('creations.selected_creation')}</p>
            <SelectInput
                label={t('creations.type')}
                options={typeData?.getCreationTypes ? typeData.getCreationTypes : []}
                getOptionLabel={(option) => t(option.name)}
                getOptionValue={(option) => option.id}
                onChange={(option) => setItem({ ...item, type: option.id })}
                error={errors.type}

            />

            {
                errors.generic ?
                    <div className='error-message'>
                        <span>{errors.generic}</span>
                    </div>
                    :
                    <></>
            }
        </Modal>
    )
}

export default EditCreationModal